import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static targets = [ "panel", "toggleButton" ]
   static values = { expanded: { type: Boolean, default: false } }

   connect() {
      if(this.expandedValue) {
         this.show();
      } else {
         this.hide();
      }
      if (this.hasToggleButtonTarget) {
         this.toggleButtonTarget.setAttribute('aria-controls', this.panelTarget.id);
      }
   }

   toggle() {
      if(this.expandedValue) {
         this.hide();
      } else {
         this.show();
      }
   }

   show() {
      this.expandedValue = true;
      this.panelTarget.style.display = 'block';

      if (this.hasPanelTarget) {
         this.panelTarget.style.display = 'block';
      }

      if (this.hasToggleButtonTarget) {
         this.toggleButtonTarget.setAttribute('aria-expanded', true);
         this.toggleButtonTarget.querySelectorAll('.show').forEach(el => {
            el.style.visibility = "hidden";
            el.setAttribute('aria-hidden', true);
         });
         this.toggleButtonTarget.querySelectorAll('.hide').forEach(el => {
            el.style.visibility = "visible";
            el.setAttribute('aria-hidden', false);
         });
      }
   }

   hide() {
      this.expandedValue = false;

      if (this.hasPanelTarget) {
         this.panelTarget.style.display = 'none';
      }

      if (this.hasToggleButtonTarget) {
         this.toggleButtonTarget.setAttribute('aria-expanded', false);
         this.toggleButtonTarget.querySelectorAll('.show').forEach(el => {
            el.style.visibility = "visible";
            el.setAttribute('aria-hidden', false);
         });
         this.toggleButtonTarget.querySelectorAll('.hide').forEach(el => {
            el.style.visibility = "hidden";
            el.setAttribute('aria-hidden', true);
         });
      }
   }
}
